export const api = {
    // main:'/api',https://czc.dzuo.net\
    // domain: 'https://czc.guanmini.com',
	  // main: 'https://czc.guanmini.com', //主域名
    main: 'https://www.guanmini.com',
    domain: 'https://www.guanmini.com', 
    // main:'https://czc.guanmini.com',
    getBackground: '/admin/Background/getBackground',
    getPaster: '/admin/Paster/getPaster',
    getFrame: '/admin/Frame/getFrame',
    getBuiltUp: '/admin/BuiltUp/getBuiltUp',
    addBuiltUp: '/admin/BuiltUp/edit',
    buildUpDetail: '/admin/BuiltUp/detail',
    getPlateSizeDetail: '/api/SelfTemplate/getContentSize',
    addPlateContent: '/admin/TemplateContent/add',
    updatePlateContent: '/admin/TemplateContent/edit',
    getPlateRows: '/api/SelfTemplate/templatePages',
    getPlatePageDetail: '/api/SelfTemplate/templatePageDetail',
    delPlateContent: '/admin/TemplateContent/delete',
    albumAdd: '/api/Oss/add',
    searchPlate: '/admin/TemplateContent/getTemplateList',
    copyPlate: '/admin/TemplateContent/copyTemplateContent',
    getFonts: '/admin/Fonts/getFonts',
    updatePlateContent2: '/admin/TemplateContent/editBase',
    copyNewTpl:'/api/SelfTemplate/copySelfTemplate',
    copyPageToStudent:'/api/SelfTemplate/copyToStudent',
    delPrivateTpl:'/api/SelfTemplate/delTemplate',
    currentTpl:'/api/SelfTemplate/currentTemplate',
    resetTpl:'/api/SelfTemplate/resetStudentPage',
    resetPrivateTpl:'/api/SelfTemplate/resetPage',
    contentMove:'/api/SelfTemplate/copyToSelfTemplate',
    batchDel:'/api/SelfTemplate/batchDelElement',
    resetDel:'/api/SelfTemplate/replayElement',
    addDrag:'/api/SelfTemplate/addElement',
    editDrag:'/api/SelfTemplate/editElement',
    editBg:'/api/SelfTemplate/editBg',
    editAllPage:'/api/SelfTemplate/editPage',
    getPaster2:'/api/GrowUpContent/getPaster',
    getBuiltUp2:'/api/GrowUpContent/getBuiltUp',
    personalPhoto:'/api/Personal/index',
    //
    getBackground2:'/api/GrowUpContent/getBackground',
    getPaster2:'/api/GrowUpContent/getPaster',
    getFrame2:'/api/GrowUpContent/getFrame',
    getBuiltUp2:'/api/GrowUpContent/getBuiltUp',
    getPhoto2:'/api/GrowUpContent/getPhoto',
    batchDel:'/api/GrowUpContent/batchDelElement',
    batchAdd:'/api/GrowUpContent/batchAddElement',
    batchEdit:'/api/GrowUpContent/batchEditElement',
    batchEditBg:'/api/GrowUpContent/batchEditBg',
    batchGetElement:'/api/GrowUpContent/batchGetElement',
    growPages:'/api/GrowUpContent/getContentList',
    changeTplName:'/api/SelfTemplate/editTemplate'
  }
  